import type {
  ReportSupplementNoticeFragmentConfig,
  TemplateSection,
} from "../../types/reportTemplate";
import type { ReportSupplementGroup } from "./reportSupplementGroups";

export function insertReportSupplementNotices(
  sections: TemplateSection[],
  groups: ReportSupplementGroup[]
): TemplateSection[] {
  const withNotices = insertHeaderNotices(sections);
  if (
    !groups.some(
      (group) => group.type === "corrected" || group.type === "amended"
    )
  )
    return withNotices;
  const detailsIndex = correctionDetailsIndex(withNotices);
  const details = noticeSection("details");
  return [
    ...withNotices.slice(0, detailsIndex),
    details,
    ...withNotices.slice(detailsIndex),
  ];
}

function insertHeaderNotices(sections: TemplateSection[]): TemplateSection[] {
  const existingIndex = sections.findIndex(
    (section) => section.type === "report_supplement_notices"
  );
  if (existingIndex >= 0)
    return sections.map((section, index) =>
      index === existingIndex
        ? {
            ...section,
            config: { ...section.config, correctionPlacement: "banner" },
          }
        : section
    );
  const insertionIndex = Math.max(
    0,
    sections.findIndex((section) => section.type === "header") + 1
  );
  const notice = noticeSection("banner");
  return [
    ...sections.slice(0, insertionIndex),
    notice,
    ...sections.slice(insertionIndex),
  ];
}

export function selectSupplementNoticeFragments(
  section: TemplateSection,
  fragments: ReportSupplementNoticeFragmentConfig[]
): ReportSupplementNoticeFragmentConfig[] {
  if (section.config?.correctionPlacement === "details")
    return fragments
      .filter(
        (fragment) =>
          fragment.groupType === "corrected" || fragment.groupType === "amended"
      )
      .map((fragment) => ({ ...fragment, showBanner: false }));
  if (section.config?.correctionPlacement === "banner")
    return fragments
      .filter((fragment) => fragment.showBanner)
      .map((fragment) => ({ ...fragment, showAttribution: false }));
  return fragments;
}

function noticeSection(
  correctionPlacement: "banner" | "details"
): TemplateSection {
  return {
    type: "report_supplement_notices",
    label: "",
    config: { correctionPlacement },
  };
}

function correctionDetailsIndex(sections: TemplateSection[]): number {
  const mainCodesIndex = sections.findIndex(
    (section) => section.type === "cpt_icd_codes"
  );
  if (mainCodesIndex >= 0) return mainCodesIndex + 1;
  const disclaimerIndex = sections.findIndex(
    (section) => section.type === "disclaimers"
  );
  return disclaimerIndex >= 0 ? disclaimerIndex : sections.length;
}
